import React from 'react';

const HelpToBuyLogo = () => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="help-to-buy"
        >
            <rect width="40" height="40" rx="2" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.6272 21.0324C35.6272 29.6837 28.6304 36.6962 19.9988 36.6962C11.3673 36.6962 4.37036 29.6837 4.37036 21.0324C4.37036 12.3813 11.3673 5.36865 19.9988 5.36865C28.6304 5.36865 35.6272 12.3813 35.6272 21.0324Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.9987 37.07C11.1771 37.07 4 29.8769 4 21.0349C4 12.1931 11.1771 5 19.9987 5C28.8206 5 35.9974 12.1931 35.9974 21.0349C35.9974 29.8769 28.8206 37.07 19.9987 37.07ZM19.9987 5.74213C11.5853 5.74213 4.74033 12.6023 4.74033 21.0349C4.74033 29.4677 11.5853 36.3279 19.9987 36.3279C28.4119 36.3279 35.2568 29.4677 35.2568 21.0349C35.2568 12.6023 28.4119 5.74213 19.9987 5.74213Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.4379 17.5295V22.9735H15.2134H11.4363H11.0469V22.383V17.5295H9.80118L9.40234 16.6024L15.0389 10.5721L15.4385 10.145L15.8374 10.5721L21.4732 16.6024L21.0743 17.5295H19.8026H15.4379ZM19.0125 11.1816H17.6311V11.9455L19.0125 13.4236V11.1816Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.8719 22.9733V21.0552H17.3077V22.9733H16.0859V18.1787H17.3077V19.98H18.8719V18.1787H20.0943V22.9733H18.8719Z"
                fill="#006267"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.3393 21.5021H21.6501C21.7151 21.9297 22.0702 22.1827 22.4908 22.1827C22.7815 22.1827 22.969 22.0661 23.1434 21.8454H24.2429C23.9324 22.5647 23.2988 23.0897 22.4908 23.0897C21.4437 23.0897 20.5903 22.2345 20.5903 21.1849C20.5903 20.1415 21.4175 19.2539 22.4713 19.2539C23.5703 19.2539 24.3655 20.1351 24.3655 21.2175C24.3655 21.3143 24.3593 21.4051 24.3393 21.5021ZM22.478 20.1611C22.09 20.1611 21.7476 20.388 21.6632 20.7767H23.2923C23.208 20.388 22.8652 20.1611 22.478 20.1611Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.8311 22.9733H25.9041V18.1787H24.8311V22.9733Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.6409 23.0966C28.214 23.0966 27.8523 22.967 27.5613 22.6495V24.1721H26.4883V19.3776H27.4963V19.7727H27.5033H27.5155C27.7936 19.4228 28.1947 19.2544 28.6347 19.2544C29.7462 19.2544 30.3862 20.1676 30.3862 21.2109C30.3862 22.2154 29.6881 23.0966 28.6409 23.0966ZM28.4144 20.2587C27.8978 20.2587 27.5155 20.6669 27.5155 21.1787C27.5155 21.6843 27.9041 22.0922 28.4144 22.0922C28.9252 22.0922 29.3133 21.6843 29.3133 21.1787C29.3133 20.6669 28.9318 20.2587 28.4144 20.2587Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.6501 26.004V28.7832H11.577V26.004H11.0469V25.1876H11.577V23.9888H12.6501V25.1876H13.1673V26.004H12.6501Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.1907 28.8938C14.092 28.8938 13.2578 28.0837 13.2578 26.9822C13.2578 25.8807 14.092 25.0708 15.1907 25.0708C16.2895 25.0708 17.1236 25.8807 17.1236 26.9822C17.1236 28.0837 16.2895 28.8938 15.1907 28.8938ZM15.1907 26.0752C14.6928 26.0752 14.3309 26.4964 14.3309 26.9822C14.3309 27.4682 14.6928 27.8893 15.1907 27.8893C15.6884 27.8893 16.0505 27.4682 16.0505 26.9822C16.0505 26.4964 15.6884 26.0752 15.1907 26.0752Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.9542 28.3688C21.4628 28.7899 21.0103 28.7837 20.3899 28.7837H18.8706V23.9888H20.3444C20.9199 23.9888 21.4628 23.9954 21.8767 24.4553C22.0771 24.6758 22.1612 24.9477 22.1612 25.2458C22.1612 25.6537 21.9605 26.0104 21.6048 26.2113C22.1292 26.3925 22.394 26.7816 22.394 27.3255C22.394 27.7079 22.2515 28.1162 21.9542 28.3688ZM20.5121 24.9886H19.9437V25.8854H20.5041C20.823 25.8854 21.0874 25.7919 21.0874 25.4247C21.0874 25.0583 20.815 24.9886 20.5121 24.9886ZM20.6488 26.7684H19.9437V27.7727H20.6418C20.9904 27.7727 21.3019 27.6536 21.3019 27.2443C21.3019 26.8504 20.9757 26.7684 20.6488 26.7684Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.0865 28.7832V28.4011H25.0734C24.8863 28.7899 24.5434 28.9003 24.1429 28.9003C23.748 28.9003 23.3478 28.7642 23.0886 28.4463C22.7979 28.0835 22.7659 27.7856 22.7659 27.3388V25.1875H23.8388V27.1765C23.8388 27.5847 23.9295 27.8958 24.4144 27.8958C24.86 27.8958 25.0278 27.5784 25.0278 27.1638V25.1875H26.1011V28.7832H25.0865Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.2876 29.9821H27.1495L27.7186 28.6022L26.3867 25.1875H27.5309L28.2487 27.2739H28.2616L28.9468 25.1875H30.0843L28.2876 29.9821Z"
                fill="#009394"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.9997 34.4683C12.5973 34.4683 6.59377 28.4524 6.59377 21.0308C6.59377 13.609 12.5973 7.59578 19.9997 7.59578C27.4033 7.59578 33.4049 13.609 33.4049 21.0308C33.4049 28.4524 27.4033 34.4683 19.9997 34.4683ZM19.9999 6.8584C12.2005 6.8584 5.85547 13.218 5.85547 21.0349C5.85547 28.8523 12.2005 35.2117 19.9999 35.2117C27.7991 35.2117 34.1448 28.8523 34.1448 21.0349C34.1448 13.218 27.7991 6.8584 19.9999 6.8584Z"
                fill="#009394"
            />
        </svg>
    );
};

export default HelpToBuyLogo;
